import roboto400 from '../../../../public/resource/googleFont/roboto-v47-latin-regular.woff2'
import roboto500 from '../../../../public/resource/googleFont/roboto-v47-latin-500.woff2'
import roboto600 from '../../../../public/resource/googleFont/roboto-v47-latin-600.woff2'
import roboto700 from '../../../../public/resource/googleFont/roboto-v47-latin-700.woff2'
import roboto800 from '../../../../public/resource/googleFont/roboto-v47-latin-800.woff2'
import roboto900 from '../../../../public/resource/googleFont/roboto-v47-latin-900.woff2'
import robotoCondensed from '../../../../public/resource/googleFont/roboto-condensed-v27-latin-700.woff2'

export const fonts = [
  new FontFace('Roboto', `url(${roboto400})`, { style: 'normal', weight: '400' }),
  new FontFace('Roboto', `url(${roboto500})`, { style: 'normal', weight: '500' }),
  new FontFace('Roboto', `url(${roboto600})`, { style: 'normal', weight: '600' }),
  new FontFace('Roboto', `url(${roboto700})`, { style: 'normal', weight: '700' }),
  new FontFace('Roboto', `url(${roboto800})`, { style: 'normal', weight: '800' }),
  new FontFace('Roboto', `url(${roboto900})`, { style: 'normal', weight: '900' }),
  new FontFace('RobotoCondensed', `url(${robotoCondensed})`, { style: 'normal', weight: '700' }),
]

export const loadFonts = async () => {
  await Promise.all(fonts.map(font => font.load()))
  fonts.forEach(font => (document.fonts as FontFaceSet).add(font))
}
